import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'app-pass-key-terms-success-form',
  templateUrl: './pass-key-terms-success-form.component.html',
  styleUrl: './pass-key-terms-success-form.component.scss',
  standalone: false
})
export class PassKeyTermsSuccessFormComponent implements OnInit {

  onPasskeySuccessContinueSubmit: (payload: object) => void;
  isSuccess: boolean;
  gotoLink: any;
  client: any;

   constructor(private readonly translate: TranslateService,
     private readonly cookieService: CookieService
   ){}

  ngOnInit(): void {
    this.client  = this.cookieService.get('client');

    if (this.client === 'shaw'){
      this.gotoLink = 'passkey.shaw.gotoMyRogers'
    }
    else if (this.client === 'shaw_direct'){
      this.gotoLink = 'passkey.shawDirect.gotoMyRogers'
    }
    else if (this.client === 'shaw_enterprise'){
      this.gotoLink = 'passkey.shawEnterprise.gotoMyRogers'
    }
    else{
      this.gotoLink = 'passkey.register.gotoMyRogers'
    }
  }

  onPasskeySuccessContinueClick(){
    this.onPasskeySuccessContinueSubmit({});
  }

}
